import BaseAPIService from '../base/base-api-service';
import ListModel from 'src/model/list.model';
import ListItemModel from 'src/model/listItem.model';

class ListsService extends BaseAPIService<ListModel> {
  private endpoint: string = '/accountapp/v1';

  private LISTS_ENDPOINT: string = '/lists';
  private ADD_ITEM_ENDPOINT: string = '/add';
  private ADDALL_ITEM_ENDPOINT: string = '/addAll';
  private LIST_ITEM_ENDPOINT: string = '/list/item';
  private CLEAR_LIST_SERVICE_ENDPOINT: string = '/lists/';
  private LISTSALL_ENDPOINT: string = '/lists?size=100';

  constructor() {
    super(ListModel);
  }
  public clearListService(listNumber: number): Promise<string> {
    console.log('listNumber', listNumber);
    return this.doRequest({
      method: 'DELETE',
      baseURL: this.baseURL,
      url: `${this.endpoint}${this.CLEAR_LIST_SERVICE_ENDPOINT}${listNumber}/clearAll`
    })
      .then(response => {
        return response;
      })
      .catch(error => {
        console.error(error);
        throw error;
      });
  }

  public getLists(): Promise<string[]> {
    return this.doRequest({
      baseURL: this.baseURL,
      url: `${this.endpoint}${this.LISTSALL_ENDPOINT}`
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        console.error(error);
        throw error;
      });
  }

  public getList(id: number): Promise<ListModel> {
    return this.doRequest({
      baseURL: this.baseURL,
      url: `${this.endpoint}${this.LISTS_ENDPOINT}/${id}`
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        console.error(error);
        throw error;
      });
  }

  public createList(listName: string): Promise<ListModel> {
    return this.doRequest({
      baseURL: this.baseURL,
      url: `${this.endpoint}${this.LISTS_ENDPOINT}`,
      data: { listName },
      method: 'post'
    })
      .then(response => {
        return response;
      })
      .catch(error => {
        console.error(error);
        throw error;
      });
  }

  public updateList(id: number, listName: string): Promise<ListModel> {
    return this.doRequest({
      baseURL: this.baseURL,
      data: { listName },
      method: 'PUT',
      url: `${this.endpoint}${this.LISTS_ENDPOINT}/${id}`
    }).then(res => {
      return res;
    });
  }

  public deleteList(id: number): Promise<string> {
    return this.doRequest({
      method: 'DELETE',
      baseURL: this.baseURL,
      url: `${this.endpoint}${this.LISTS_ENDPOINT}/${id}`
    })
      .then(response => {
        return response;
      })
      .catch(error => {
        console.error(error);
        throw error;
      });
  }

  public addItem(
    listId: number | string,
    itemName: string,
    manufacturerCode: string,
    quantity?: number,
    shipmentMarking?: string,
    warrantyProvider?: string,
    dispatch?: string
  ) {
    const data = {
      listId,
      itemName,
      manufacturerCode,
      quantity,
      shipmentMarking,
      warrantyProvider,
      dispatch
    };
    return this.doRequest({
      baseURL: this.baseURL,
      data,
      method: 'post',
      url: `${this.endpoint}${this.LIST_ITEM_ENDPOINT}${this.ADD_ITEM_ENDPOINT}`
    }).then(res => {
      return ListItemModel.cast<ListItemModel>(res.data, ListItemModel);
    });
  }

  public deleteItem(itemId: number): Promise<string> {
    return this.doRequest({
      method: 'DELETE',
      baseURL: this.baseURL,
      url: `${this.endpoint}${this.LIST_ITEM_ENDPOINT}/${itemId}`
    })
      .then(response => {
        return response;
      })
      .catch(error => {
        console.error(error);
        throw error;
      });
  }

  public updateItem(
    itemId: number,
    itemName: string,
    manufacturerCode: string,
    quantity: number,
    shipmentMarking: string,
    warrantyProvider: string,
    dispatch: string
  ) {
    const data = {
      itemName,
      manufacturerCode,
      quantity,
      shipmentMarking,
      warrantyProvider,
      dispatch
    };
    return this.doRequest({
      baseURL: this.baseURL,
      data,
      method: 'PUT',
      url: `${this.endpoint}${this.LIST_ITEM_ENDPOINT}/${itemId}`
    }).then(res => {
      return res.data;
    });
  }
}

const listsServiceInstance = new ListsService();
Object.freeze(listsServiceInstance);

export default listsServiceInstance;
